import { html, LitElement } from 'lit';
import { property, state } from 'lit/decorators.js';
import { IntraportalNavStyles } from './ix-intraportal-nav-styles.js';

export class IxIntraportalNav extends LitElement {
  static get styles() {
    return [IntraportalNavStyles];
  }

  @property({ type: Array }) navItems = [
    {
      label: 'Home',
      href: '/home',
      selected: true,
      beforeSelected: false,
      target: '_self',
    },
  ];

  @state() menuOpen = false;

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  setHeight = async () => {
    const height = this.offsetHeight;
    document.body.style.setProperty('--intraportal-nav-height', `${height}px`);
  };

  updated(_changedProperties: Map<string | number | symbol, unknown>) {
    super.updated(_changedProperties);

    if (_changedProperties.has('navItems')) {
      const selectedId = this.navItems.findIndex(item => item.selected);
      if (selectedId > 0 && !this.navItems[selectedId - 1].beforeSelected) {
        const navItems = [...this.navItems];
        navItems[selectedId - 1].beforeSelected = true;
        this.navItems = navItems;
      }
    }
    this.setHeight();
    setTimeout(() => {
      this.setHeight();
    }, 2000);
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('resize', this.setHeight);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('resize', this.setHeight);
  }

  protected override render() {
    return html` <div class="mobile-menu ${this.menuOpen ? 'open' : ''}">
        <button aria-expanded=${this.menuOpen} @click=${this.toggleMenu}>
          Global Portal
        </button>
      </div>
      <nav aria-label="Intraportal navigation menu">
        ${this.navItems.map(
          item =>
            html`<a
              href="${item.href}"
              class="${item.selected ? 'selected' : ''} ${item.beforeSelected
                ? 'before-selected'
                : ''}"
              target=${item.target || '_self'}
              ><span>${item.label}</span></a
            >`
        )}
      </nav>`;
  }
}
